export default __webpack_public_path__ + "static/media/grass.2cf24083.jpg";